import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import {jsonObject, pickAttributes, pickHeader} from '../../data/picks/pick';
import RequestDefinition from '../RequestDefinition';
import ObjectDefinition from '../ObjectDefinition';

export default new RouteComponent(`${apiRoutePrefix}/picks`, () => {
    return (
        <div>
            <ObjectHeader data={ pickHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The pick object',
                attributes: pickAttributes,
                jsonObject: jsonObject
            } }/>

            {
                pickHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
